import { useRef } from 'react'

import { useSize } from 'ahooks'

export function useOverflow<
  Container extends HTMLElement,
  Content extends HTMLElement
>() {
  const containerRef = useRef<Container>(null)
  const contentRef = useRef<Content>(null)

  const containerSize = useSize(containerRef)
  const contentSize = useSize(contentRef)

  return {
    containerRef,
    contentRef,
    overflow: (containerSize?.width || 0) <= (contentSize?.width || 0)
  }
}
